import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  Input,
  OnInit,
  WritableSignal,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EnvironmentsService } from '@core/services/environments/environments.service';
import { Idle } from '@ng-idle/core';
import { ModalService } from '@shared/services';

@Component({
  standalone: false,
  selector: 'gstar-timeout-modal',
  templateUrl: './timeout-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeoutModalComponent implements OnInit {
  private readonly environmentService = inject(EnvironmentsService);
  private readonly modalService = inject(ModalService);
  private readonly idle = inject(Idle);

  @Input() modalId!: string;
  timeCounter: WritableSignal<number> = signal(
    this.environmentService.timeBeforeClose
  );
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.idle.onTimeoutWarning
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((time: number) => {
        this.timeCounter.set(time);
      });

    this.idle.onTimeout
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.timeCounter.set(0);
        this.modalService.close(this.modalId, false);
      });
  }
}
